import { forwardRef } from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	color?: 'primary' | 'secondary' | 'danger' | 'success' | 'warning' | 'info' | 'light' | 'default' | 'dark';
	size?: 'xs' | 'sm' | 'md' | 'lg';
	variant?: 'text' | 'outlined' | 'contained';
	type?: 'button' | 'submit' | 'reset';
	icon?: string;
	iconPosition?: 'left' | 'right';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
	const { children, color, size, type, icon, className, iconPosition = 'left', ...rest } = props;
	const sizeClass = size && size !== 'md' ? `btn-${size}` : 'btn-sm';
	const finalClassName = `${className ? className : ''} gwp-btn btn btn-${color || 'blue'} ${sizeClass}`.trim();

	return (
		<button ref={ref} type={type || 'button'} className={finalClassName} {...rest}>
			{icon && iconPosition === 'left' && <i className={`${icon} ${children !== undefined ? 'gwp-icon-left' : ''}`} />}
			{children}
			{icon && iconPosition === 'right' && <i className={`${icon} ${children !== undefined ? 'gwp-icon-right' : ''}`} />}
		</button>
	);
});
Button.displayName = 'Button';

export default Button;
